module.exports = __webpack_public_path__ + "static/media/03_DSC7759.b9579d76.jpg";